/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

import {ref} from 'vue';

export interface EmployeeMentionPic {
  empNumber: number;
  firstName: string;
  lastName: string;
  middleName?: string | null;
  nickName?: string | null;
}

export interface EmployeeMentionContext {
  assignedPic?: EmployeeMentionPic | null;
}

const show = ref(false);
const empNumber = ref<number | null>(null);
const assignedPic = ref<EmployeeMentionPic | null>(null);

export default function useBuzzEmployeeMentionDialog() {
  const openEmployeeMention = (
    id: number,
    context?: EmployeeMentionContext,
  ) => {
    empNumber.value = id;
    assignedPic.value = context?.assignedPic ?? null;
    show.value = true;
  };

  const closeEmployeeMention = () => {
    show.value = false;
    empNumber.value = null;
    assignedPic.value = null;
  };

  return {
    show,
    empNumber,
    assignedPic,
    openEmployeeMention,
    closeEmployeeMention,
  };
}
